// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { jwtDecode } from "jwt-decode";
// import { useDispatch, useSelector } from "react-redux";
// import { logoutUser } from "../state/slices/userSlice";
// import authService, { getRole } from "../services/auth.service";

// const isTokenExpired = (token) => {
//   if (!token) return true; // If no token is available
//   const { exp } = jwtDecode(token); // Decode the token and get expiration time
//   if (Date.now() >= exp * 1000) {
//     return true; // Token is expired
//   }
//   return false;
// };

// const ProtectedRoute = () => {
//   const dispatch = useDispatch();
//   const userRole = getRole();
//   if (
//     !userRole.includes("Admin") ||
//     isTokenExpired(sessionStorage.getItem("token"))
//   ) {
//     dispatch(logoutUser());
//     sessionStorage.removeItem("token");
//     return <Navigate to="/login" />;
//   }
//   return <Outlet />;
// };
// export default ProtectedRoute;
import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../state/slices/userSlice";
import { getRole, isTokenExpired } from "../services/auth.service";

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const token = sessionStorage.getItem("token");
  const isTokenExpiredBoolean = isTokenExpired(token);
  const userRole = getRole();

  useEffect(() => {
    if (!userRole.includes("Admin") || isTokenExpiredBoolean) {
      dispatch(logoutUser());
      sessionStorage.removeItem("token");
    }
  }, [dispatch, userRole, isTokenExpiredBoolean]);

  if (!userRole.includes("Admin") || isTokenExpiredBoolean) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
